export default __webpack_public_path__ + "static/media/galleryModalCloseLogo.699ad4a0.svg";